import { Lock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Switch } from '@/components/ui/primitives';
import type { AddOnState } from './add-ons';

export function AddOnToggles({
  states,
  onToggle,
  busyCode,
  readOnly = false,
}: {
  states: AddOnState[];
  onToggle: (state: AddOnState) => void;
  busyCode?: string | null;
  readOnly?: boolean;
}) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {states.map((state) => {
        const locked = Boolean(state.problem);
        return (
          <div
            key={state.code}
            title={state.problem ?? undefined}
            className={cn(
              'rounded-lg border p-3 transition-colors',
              state.on ? 'border-primary/40 bg-primary/5' : 'bg-background',
              !locked && 'hover:border-primary/30',
            )}
          >
            <Switch
              checked={state.on}
              onCheckedChange={() => onToggle(state)}
              disabled={locked || readOnly || busyCode === state.code}
              label={
                <span className="flex items-center gap-1.5 font-medium">
                  {state.name}
                  {locked && <Lock className="h-3 w-3 text-muted-foreground" aria-hidden />}
                </span>
              }
              description={state.problem ?? state.description}
            />
          </div>
        );
      })}
    </div>
  );
}
